/**
 * Shared vocabulary for the List/Kanban field filters (#1242).
 *
 * The narrowing itself moved server-side (#1269): both surfaces send these
 * dimensions as query params on GET /demands, where they are applied before
 * the count and the page — so every total shown is the truth about the
 * filtered set, not about what happened to load. The SQL mirrors of the old
 * client rules live in routers/demands.py, pinned by
 * tests/test_demand_list_server_filters.py.
 *
 * What remains here is the one UI vocabulary both surfaces render from.
 */

export const STAFFING_FILTER_OPTIONS: { key: string; label: string }[] = [
  { key: 'staffed', label: 'Staffed' },
  { key: 'needs_staffing', label: 'Needs staffing' },
]
